import { Form, Input } from '@arco-design/web-react';

import { VENDOR_DEVICE_FIELD_KEYS } from './types';

const FormItem = Form.Item;

interface VendorDevicePersistFieldsProps {
  fieldPrefix: string;
}

/** 厂商设备隐藏 FormItem：vendor / vendorID / device / deviceID / deviceType / billItemId / quantityUnit */
export function VendorDevicePersistFields({ fieldPrefix }: VendorDevicePersistFieldsProps) {
  return (
    <>
      {VENDOR_DEVICE_FIELD_KEYS.map((key) => (
        <FormItem key={key} field={`${fieldPrefix}.${key}`} hidden>
          <Input />
        </FormItem>
      ))}
    </>
  );
}
